import * as Yup from 'yup';
import * as message from '../../../constant/message';

export const loginSchema = Yup.object().shape({
  email: Yup.string().email(message.INVALID_EMAIL).required(message.EMAIL),
  password: Yup.string().min(8, message.PASSWORD_MIN_LENGTH).required(message.PASSWORD_REQUIRED),
});
